import React, { useEffect, memo, useCallback, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory } from 'react-router-dom';

import { gameCDKCodeVisible } from '../../actions/gamecdk';
import { logging } from '../../actions/log';
import styles from './Gamecdk.module.less';
import { logNative, changeClass } from '../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectGameCDK = createSelector(
  state => state.gamecdk,
  gamecdk => gamecdk,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const { gamecdkCodeShow } = useSelector(selectGameCDK); // 展示iframe

  const [showPageDom, setShowPageDom] = useState(true); // 页面加载态是否时间到了
  const [pageState, setPageState] = useState(3); // 页面状态    3: 获取cdk成功  4: 失败
  const iframeCodeRef = useRef(null);

  const codeRef = useRef(null);
  const errorRef = useRef(null);

  useEffect(() => {
    // 快捷方式弹窗 PV
    dispatch(
      logging({
        category: 'P',
        action: 'Shop_Mall',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, []);

  // 控制展示哪一个页面
  useEffect(() => {
    if (checkPage()) {
      pageState === 3 && showPage('code');
      pageState === 4 && showPage('error');
    }
  }, [pageState, codeRef, errorRef]);

  const handleUpdate = useCallback(() => {
    setPageState(3);
    setShowPageDom(false);
    setTimeout(() => {
      setShowPageDom(true);
    }, 1000);
  }, []);

  const handleIframeCDKOnLoad = useCallback(() => {
    logNative(`游戏cdk展示, 加载凤凰兑换码页面完成`);
  }, []);
  const handleIframeCDKOnError = useCallback(() => {
    setPageState(3);
    logNative(`游戏cdk展示, 加载凤凰兑换码页面失败`);
  }, []);

  const handleClose = useCallback(() => {
    // 关闭商城框
    dispatch(
      logging({
        category: 'C',
        action: 'Shop_Mall_Close',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      gameCDKCodeVisible({
        isShow: false,
      }),
    );
  }, []);

  const checkPage = useCallback(() => {
    if (codeRef && errorRef && codeRef?.current && errorRef?.current) {
      return true;
    }
    return false;
  }, [codeRef, errorRef]);

  const showPage = useCallback(
    page => {
      if (checkPage()) {
        changeClass(codeRef?.current, styles.gamecdk_page_out, styles.gamecdk_page_in);
        changeClass(errorRef?.current, styles.gamecdk_page_out, styles.gamecdk_page_in);
        let dom = codeRef?.current;
        page === 'code' && (dom = codeRef?.current);
        page === 'error' && (dom = errorRef?.current);
        setTimeout(() => {
          changeClass(dom, styles.gamecdk_page_in, styles.gamecdk_page_out);
        }, 0);
      }
    },
    [codeRef, errorRef],
  );

  return (
    <div className={styles.cdk_bg}>
      <div className={styles.cdk}>
        <div className={styles.cdk_header}>
          <div className={styles.cdk_header_title}>激活码购买</div>
          <div
            className={`${styles.cdk_header_close} iconfont icon-opt_close`}
            onClick={handleClose}
          ></div>
        </div>
        <div className={styles.cdk_body}>
          <div className={styles.cdk_code} ref={codeRef}>
            {showPageDom && (
              <iframe
                onLoad={handleIframeCDKOnLoad}
                onError={handleIframeCDKOnError}
                ref={iframeCodeRef}
                src={`${gamecdkCodeShow?.exchangeUrl}`}
                style={{ width: '725px', height: '370px', border: 'none' }}
              />
            )}
          </div>

          <div className={styles.cdk_error} ref={errorRef}>
            <div className={styles.cdk_error_info}>
              <div className={`${styles.cdk_error_icon} iconfont icon-gcdk_error`}></div>
              <div className={styles.cdk_error_info_text}>激活码走丢了...</div>
            </div>
            <div className={styles.cdk_error_text}>{'很抱歉，网络异常，请稍后再试'}</div>
            <div className={styles.cdk_error_btn} onClick={handleUpdate}>
              刷新
            </div>
          </div>
        </div>
      </div>
      <div className={styles.cdk_order}></div>
    </div>
  );
});
